module.exports = "<p>\r\n  home-dashboard works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/components/home-dashboard.component.html
// module id = ./src/app/home/components/home-dashboard.component.html
// module chunks = main